import { render, staticRenderFns } from "./ChipMultiSelect.vue?vue&type=template&id=5c0435af&scoped=true&"
import script from "./ChipMultiSelect.vue?vue&type=script&lang=js&"
export * from "./ChipMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./ChipMultiSelect.vue?vue&type=style&index=0&id=5c0435af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0435af",
  null
  
)

export default component.exports